

import React, { useState, useEffect, useMemo } from "react";
import headshot from './assets/headshot.png';
import securitypluslogo from './assets/securitypluslogo.png';
import networkpluslogo from './assets/networkpluslogo.png';
import az900 from './assets/az900.png';
import az500 from './assets/az500.png';
import splunk from './assets/splunk.png';
// import Logo from './components/Logo';

import {
  Mail,
  Github,
  Linkedin,
  Download,
  Eye,
  ExternalLink,
  Share2,
  // Menu,
  X,
  Sun,
  Moon,
  Check,
} from "lucide-react";

export default function CybersecurityPortfolio() {
  const [showStickyHeader, setShowStickyHeader] = useState(false);
  const [selectedPDF, setSelectedPDF] = useState(null);
  const [isDarkMode, setIsDarkMode] = useState(true);
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    subject: "",
    message: "",
  });
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [showSuccessModal, setShowSuccessModal] = useState(false);
  const [showCopyAlert, setShowCopyAlert] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      const profilePicture = document.getElementById("profile-picture");
      if (profilePicture) {
        const rect = profilePicture.getBoundingClientRect();
        // Show header immediately after scrolling past the profile picture
        setShowStickyHeader(rect.bottom <= 0);
      }
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  
// HERE BUDDY!
  const handleFormSubmit = async (e) => {
  e.preventDefault();
  setIsSubmitting(true);

  try {
    // Determine API URL based on environment
    // In development: use localhost if backend is running locally
    // In production: use production API URL
    const isDevelopment = window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1';
    const API_URL = process.env.REACT_APP_API_URL || 
                    (isDevelopment ? 'http://localhost:3001' : 'https://api.ifeoluwa.dev');
    const contactEndpoint = `${API_URL}/api/contact`;
    
    console.log('Environment:', isDevelopment ? 'Development' : 'Production');
    console.log('Sending request to:', contactEndpoint);
    console.log('Form data:', formData);

    const response = await fetch(contactEndpoint, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(formData),
    });

    console.log('Response status:', response.status);
    console.log('Response headers:', Object.fromEntries(response.headers));

    // Try to parse response as JSON
    let responseData;
    const contentType = response.headers.get('content-type');
    
    if (contentType && contentType.includes('application/json')) {
      responseData = await response.json();
    } else {
      const text = await response.text();
      console.error('Non-JSON response:', text);
      throw new Error('Server returned invalid response format');
    }

    if (response.ok) {
      console.log('Success response:', responseData);
      setShowSuccessModal(true);
      setFormData({ name: "", email: "", subject: "", message: "" });
    } else {
      console.error('Error response:', responseData);
      const errorMessage = responseData.error || responseData.details || "Please try again.";
      alert(`Failed to send message: ${errorMessage}`);
    }
  } catch (error) {
    console.error("Fetch error details:", error);
    console.error("Error name:", error.name);
    console.error("Error message:", error.message);
    
    // Provide more specific error messages
    let errorMessage = "An error occurred. Please try again.";
    
    if (error.name === 'TypeError' && error.message.includes('fetch')) {
      errorMessage = "Network error: Could not connect to server. Please check your internet connection.";
    } else if (error.message) {
      errorMessage = `Error: ${error.message}`;
    }
    
    alert(errorMessage);
  } finally {
    setIsSubmitting(false);
  }
};

  const handleInputChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };

  const handleShareClick = async () => {
    try {
      await navigator.clipboard.writeText(window.location.href);
      setShowCopyAlert(true);
      setTimeout(() => setShowCopyAlert(false), 2000);
    } catch (err) {
      console.error("Failed to copy link:", err);
    }
  };

  const certifications = [
    {
    name: "CompTIA Security+",
    fullName: "CompTIA Security+ Certification",
    image: securitypluslogo,
    inProgress: false,
  },
  {
    name: "CompTIA Network+",
    fullName: "CompTIA  Network+ Certification",
    image: networkpluslogo,
    inProgress: false,
  },
  {
    name: "AZ-900",
    fullName: "Microsoft Azure Fundamentals (AZ-900) Certification",
    image: az900,
    inProgress: false,
  },
  {
    name: "Splunk Core Certified User",
    fullName: "Splunk Core Certified User Certification",
    image: splunk,
    inProgress: false,
  },
  {
    name: "AZ-500",
    fullName: "Microsoft Azure Security Engineer Associate (AZ-500) Certification",
    image: az500,
    inProgress: true,
  },
  ];

  const projects = [
    {
      id: 1,
      title: "Enterprise Network Security Assessment",
      description:
        "Comprehensive security assessment of enterprise network infrastructure including vulnerability scanning, penetration testing, and risk analysis. Identified critical vulnerabilities and provided remediation strategies.",
      type: "pdf",
      pdfUrl: "/sample-project.pdf",
      technologies: ["Nmap", "Wireshark", "Metasploit", "Nessus", "Burp Suite"],
    },
    {
      id: 2,
      title: "Mastering RSA Encryption in Python: Secure Communication Between Ubuntu and Kali",
      description:
        "Built a hands-on cybersecurity lab demonstrating RSA key generation, secure key exchange, and encrypted messaging between Ubuntu and Kali Linux virtual machines. Implemented best practices for key handling, secure file transfer, and reproducible logging.",
      type: "website",
      url: "https://medium.com/@ariboifeoluwa/mastering-rsa-encryption-in-python-secure-communication-between-ubuntu-and-kali-a400cf84acb1",
      technologies: ["Python", "Cryptography", "RSA", "Ubuntu", "Kali Linux", "VirtualBox", "scp"],
    },
    {
      id: 3,
      title: "Simulating and Defending ARP Spoofing & Ping Flood Attacks in a Virtual Lab",
      description:
        "Simulated Layer 2 and Layer 3 attacks in a controlled lab using Kali Linux as attacker and Ubuntu as defender. Implemented defenses including arpwatch, static ARP entries, and iptables to detect and mitigate ARP spoofing and ICMP flooding, validated with Wireshark and Snort packet captures.",
      type: "website",
      url: "https://medium.com/@ariboifeoluwa/simulating-and-defending-arp-spoofing-ping-flood-attacks-in-a-virtual-lab-181352a98d3a",
      technologies: ["Linux", "Kali", "Ubuntu", "Wireshark", "Snort", "arpwatch", "iptables", "VirtualBox"],
    },
  ];

  // Structured Data for SEO
  const structuredData = useMemo(() => ({
    "@context": "https://schema.org",
    "@type": "Person",
    "name": "Aribo Ifeoluwa",
    "jobTitle": "Cybersecurity Analyst",
    "url": "https://ifeoluwa.dev",
    "sameAs": [
      "https://www.linkedin.com/in/ifeoluwa-aribo-x/",
      "https://github.com/Ifeoluwa-x"
    ],
    "email": "Ariboifeoluwa@gmail.com",
    "description": "Cybersecurity Analyst, SOC Analyst, and Cloud Security Engineer specializing in penetration testing, vulnerability management, incident response, and cloud security.",
    "knowsAbout": [
      "Cybersecurity",
      "Penetration Testing",
      "Vulnerability Management",
      "Incident Response",
      "SOC Operations",
      "SIEM Analysis",
      "Threat Detection",
      "Cloud Security",
      "AWS Security",
      "Azure Security",
      "Network Security"
    ],
    "hasCredential": [
      {
        "@type": "EducationalOccupationalCredential",
        "credentialCategory": "Professional Certification",
        "name": "CompTIA Security+",
        "recognizedBy": {
          "@type": "Organization",
          "name": "CompTIA"
        }
      },
      {
        "@type": "EducationalOccupationalCredential",
        "credentialCategory": "Professional Certification",
        "name": "CompTIA Network+",
        "recognizedBy": {
          "@type": "Organization",
          "name": "CompTIA"
        }
      },
      {
        "@type": "EducationalOccupationalCredential",
        "credentialCategory": "Professional Certification",
        "name": "Microsoft Azure Fundamentals (AZ-900)",
        "recognizedBy": {
          "@type": "Organization",
          "name": "Microsoft"
        }
      },
      {
        "@type": "EducationalOccupationalCredential",
        "credentialCategory": "Professional Certification",
        "name": "Splunk Core Certified User",
        "recognizedBy": {
          "@type": "Organization",
          "name": "Splunk"
        }
      }
    ]
  }), []);

  useEffect(() => {
    // Add structured data to page
    const script = document.createElement('script');
    script.type = 'application/ld+json';
    script.text = JSON.stringify(structuredData);
    script.id = 'structured-data';
    document.head.appendChild(script);

    return () => {
      const existingScript = document.getElementById('structured-data');
      if (existingScript) {
        document.head.removeChild(existingScript);
      }
    };
  }, [structuredData]);

  return (
    <div
      className={`min-h-screen transition-colors duration-300 ${
        isDarkMode
          ? "bg-gradient-to-br from-slate-900 via-slate-800 to-slate-900 text-white"
          : "bg-gradient-to-br from-gray-50 via-white to-gray-100 text-gray-900"
      }`}
    >
      {/* Skip to main content for accessibility */}
      <a
        href="#main-content"
        className="sr-only focus:not-sr-only focus:absolute focus:top-4 focus:left-4 focus:z-50 focus:px-4 focus:py-2 focus:bg-blue-600 focus:text-white focus:rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
        aria-label="Skip to main content"
      >
        Skip to main content
      </a>
      {/* Sticky Header with Enhanced Glassy Effect */}
      <header
        role="banner"
        className={`fixed top-0 left-0 right-0 z-40 transition-all duration-300 ${
          showStickyHeader
            ? "translate-y-0 opacity-100"
            : "-translate-y-full opacity-0"
        }`}
      >
        <nav
          className={`backdrop-blur-xl border-b ${
            isDarkMode
              ? "bg-slate-900/20 border-slate-700/50"
              : "bg-white/10 border-gray-200/50"
          }`}
          style={{
            background: isDarkMode
              ? "linear-gradient(135deg, rgba(15, 23, 42, 0.1) 0%, rgba(30, 41, 59, 0.2) 100%)"
              : "linear-gradient(135deg, rgba(255, 255, 255, 0.05) 0%, rgba(255, 255, 255, 0.15) 100%)",
            boxShadow: "0 8px 32px 0 rgba(31, 38, 135, 0.37)",
            backdropFilter: "blur(20px)",
            WebkitBackdropFilter: "blur(20px)",
          }}
          aria-label="Main navigation"
        >
          <div className="max-w-6xl mx-auto px-6 py-3 flex items-center justify-between">
            <div className="flex items-center gap-3">
              {/* Clickable Logo */}
              <a
                href="/"
                aria-label="Aribo Ifeoluwa - Cybersecurity Professional Portfolio Homepage"
                className="transition-transform duration-300 hover:scale-105 focus:scale-105 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:rounded-lg group"
              >
                <img 
                  src="/logo.png" 
                  alt="Aribo Ifeoluwa Logo" 
                  className="h-16 md:h-20 w-auto transition-all duration-300 group-hover:opacity-90"
                  width="64"
                  height="64"
                />
              </a>
            </div>
            <button
              onClick={handleShareClick}
              aria-label="Share this portfolio page"
              className="group/btn relative flex items-center gap-2 px-5 py-2.5 bg-gradient-to-r from-blue-600 to-purple-600 hover:from-blue-500 hover:to-purple-500 text-white rounded-xl font-semibold text-sm transition-all duration-300 transform hover:scale-105 hover:-translate-y-0.5 hover:shadow-lg hover:shadow-blue-500/50 overflow-hidden focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2"
            >
              {/* Button glow effect */}
              <span className="absolute inset-0 bg-gradient-to-r from-purple-600 to-blue-600 opacity-0 group-hover/btn:opacity-100 transition-opacity duration-300" />
              <Share2 className="w-4 h-4 relative z-10 transition-transform duration-300 group-hover/btn:rotate-12 group-hover/btn:scale-110" aria-hidden="true" />
              <span className="relative z-10">Share</span>
            </button>
          </div>
        </nav>
      </header>

      {/* Share Copied Alert */}
      {showCopyAlert && (
        <div className="fixed top-6 left-1/2 transform -translate-x-1/2 z-[9999] bg-gradient-to-r from-green-600 to-emerald-600 text-white px-6 py-3 rounded-xl shadow-xl shadow-green-500/50 transition-all animate-fade-in-up backdrop-blur-sm border border-green-500/30">
          <div className="flex items-center gap-2">
            <Check className="w-5 h-5" />
            <span className="font-semibold">Link copied to clipboard!</span>
          </div>
        </div>
      )}

      {/* Main Content */}
      <main id="main-content" role="main">
      {/* Profile Section with Theme Toggle */}
      <section
        id="profile-section"
        aria-labelledby="profile-heading"
        className="pt-16 md:pt-24 flex items-center justify-center px-6 relative"
      >
        {/* Theme Toggle Button - Mobile: Above profile, Desktop: Top right */}
        <div className="fixed bottom-20 right-6 z-[9999]">
          <div
            className={`flex items-center gap-3 px-4 py-3 rounded-xl border backdrop-blur-md transition-all duration-300 ${
              isDarkMode
                ? "bg-slate-800/90 border-slate-600 text-white shadow-xl"
                : "bg-white/90 border-gray-300 text-gray-900 shadow-xl"
            }`}
            role="group"
            aria-label="Theme toggle"
          >
            <span className="text-sm font-medium" aria-hidden="true">
              {isDarkMode ? "Dark" : "Light"}
            </span>
            <button
              onClick={() => setIsDarkMode(!isDarkMode)}
              aria-label={`Switch to ${isDarkMode ? "light" : "dark"} mode`}
              aria-pressed={isDarkMode}
              className={`relative w-12 h-6 rounded-full transition-all duration-300 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2 ${
                isDarkMode ? "bg-blue-600" : "bg-gray-300"
              }`}
            >
              <div
                className={`absolute top-1 w-4 h-4 rounded-full transition-all duration-300 transform ${
                  isDarkMode
                    ? "translate-x-7 bg-yellow-300"
                    : "translate-x-1 bg-white"
                }`}
                aria-hidden="true"
              >
                {isDarkMode ? (
                  <Moon className="w-3 h-3 text-slate-800 absolute top-0.5 left-0.5" aria-hidden="true" />
                ) : (
                  <Sun className="w-3 h-3 text-yellow-500 absolute top-0.5 left-0.5" aria-hidden="true" />
                )}
              </div>
            </button>
          </div>
        </div>

        <div className="max-w-4xl mx-auto text-center px-4 sm:px-6">
  {/* Profile Picture */}
  <div
    id="profile-picture"
    className="mb-8 relative w-40 h-40 sm:w-48 sm:h-48 md:w-30 md:h-30 mx-auto overflow-hidden rounded-2xl border-4 border-blue-500 shadow-2xl transition-all duration-300 hover:shadow-3xl"
  >
    <img
      src={headshot}
      alt="Aribo Ifeoluwa, Cybersecurity Analyst, SOC Analyst, and Cloud Security Engineer professional headshot"
      className="w-full h-full object-cover object-center transform hover:scale-105 transition-transform duration-300"
      loading="eager"
      decoding="async"
      width="192"
      height="192"
    />
  </div>



          {/* Description */}
          <h1 id="profile-heading" className="text-5xl font-bold mb-6 bg-gradient-to-r from-blue-400 to-purple-400 bg-clip-text text-transparent">
            Aribo Ifeoluwa
          </h1>
          <h2
            className={`text-2xl mb-8 ${
              isDarkMode ? "text-slate-300" : "text-gray-600"
            }`}
          >
            Cybersecurity Analyst | SOC Analyst | Cloud Security Engineer
          </h2>
    <p
      className={`text-lg max-w-3xl mx-auto leading-relaxed mb-12 ${
        isDarkMode ? "text-slate-400" : "text-gray-600"
      }`}
    >
      Hands-on security professional with practical experience in{" "}
      <span className="text-blue-400 font-semibold">
        penetration testing
      </span>
      ,
      <span className="text-blue-400 font-semibold">
        {" "}vulnerability management
      </span>
      , and
      <span className="text-blue-400 font-semibold">
        {" "}incident response
      </span>
      . Skilled in{" "}
      <span className="text-blue-400 font-semibold">
        SOC operations
      </span>
      ,{" "}
      <span className="text-blue-400 font-semibold">
        SIEM log analysis
      </span>
      ,{" "}
      <span className="text-blue-400 font-semibold">
        threat detection
      </span>
      , and{" "}
      <span className="text-blue-400 font-semibold">
        endpoint security
      </span>
      . Strong background in{" "}
      <span className="text-blue-400 font-semibold">
        cloud security (AWS, Azure, GCP)
      </span>
      ,{" "}
      <span className="text-blue-400 font-semibold">
        identity and access management (IAM)
      </span>
      , and{" "}
      <span className="text-blue-400 font-semibold">
        secure architecture design
      </span>
      . Experienced with{" "}
      <span className="text-blue-400 font-semibold">
        threat hunting
      </span>
      ,{" "}
      <span className="text-blue-400 font-semibold">
        security automation
      </span>
      , and{" "}
      <span className="text-blue-400 font-semibold">
        compliance standards (NIST, ISO, CIS)
      </span>
      . Proven ability to apply{" "}
      <span className="text-blue-400 font-semibold">
        hands-on lab and project experience {" "}
      </span>
      to secure enterprise systems against{" "}
      <span className="text-blue-400 font-semibold">
        malware, phishing, cloud misconfigurations, and zero-day exploits
      </span>
      .
    </p>
          {/* Social Icons */}
          <nav aria-label="Social media links" className="flex justify-center gap-6">
            <a
              href="https://www.linkedin.com/in/ifeoluwa-aribo-x/"
              target="_blank"
              rel="noopener noreferrer"
              className={`p-4 transition-all duration-300 transform hover:scale-110 hover:shadow-lg rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 ${
                isDarkMode
                  ? "hover:bg-blue-600/20 text-slate-400 hover:text-blue-400"
                  : "hover:bg-blue-50 text-gray-600 hover:text-blue-600"
              }`}
              aria-label="Visit Aribo Ifeoluwa's LinkedIn profile (opens in new tab)"
            >
              <Linkedin className="w-6 h-6" aria-hidden="true" />
            </a>
            <a
              href="https://github.com/Ifeoluwa-x"
              target="_blank"
              rel="noopener noreferrer"
              className={`p-4 transition-all duration-300 transform hover:scale-110 hover:shadow-lg rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 ${
                isDarkMode
                  ? "hover:bg-gray-600/20 text-slate-400 hover:text-gray-400"
                  : "hover:bg-gray-50 text-gray-600 hover:text-gray-700"
              }`}
              aria-label="Visit Aribo Ifeoluwa's GitHub profile (opens in new tab)"
            >
              <Github className="w-6 h-6" aria-hidden="true" />
            </a>
            <a
              href="mailto:Ariboifeoluwa@gmail.com"
              target="_blank"
              rel="noopener noreferrer"
              className={`p-4 transition-all duration-300 transform hover:scale-110 hover:shadow-lg rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 ${
                isDarkMode
                  ? "hover:bg-red-600/20 text-slate-400 hover:text-red-400"
                  : "hover:bg-red-50 text-gray-600 hover:text-red-600"
              }`}
              aria-label="Send email to Aribo Ifeoluwa at Ariboifeoluwa@gmail.com (opens email client)"
            >
              <Mail className="w-6 h-6" aria-hidden="true" />
            </a>
          </nav>
        </div>
      </section>

      {/* Resume Section */}
      <section
        aria-labelledby="resume-heading"
        className={`py-12 md:py-16 px-6 ${
          isDarkMode ? "bg-slate-800/50" : "bg-gray-50/50"
        }`}
      >
        <div className="max-w-4xl mx-auto text-center">
          <h2 id="resume-heading" className="text-4xl font-bold mb-8">Resume</h2>
          <p
            className={`mb-12 text-lg ${
              isDarkMode ? "text-slate-400" : "text-gray-600"
            }`}
          >
            Download my comprehensive resume to learn more about my experience
            and qualifications.
          </p>
          <a
            href="/Aribo_Ifeoluwa_Resume.pdf"
            onClick={e => {
              e.preventDefault();
              // Open in new tab
              window.open("/Aribo_Ifeoluwa_Resume.pdf", "_blank", "noopener,noreferrer");
              // Trigger download
              const link = document.createElement("a");
              link.href = "/Aribo_Ifeoluwa_Resume.pdf";
              link.download = "Aribo_Ifeoluwa_Resume.pdf";
              document.body.appendChild(link);
              link.click();
              document.body.removeChild(link);
            }}
            aria-label="Download Aribo Ifeoluwa's resume PDF"
            className="group relative px-8 py-4 bg-gradient-to-r from-blue-600 to-purple-600 rounded-xl font-semibold text-lg text-white transition-all duration-300 transform hover:scale-105 hover:shadow-2xl overflow-hidden inline-flex items-center gap-3 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2"
          >
            <Download className="w-5 h-5 group-hover:animate-bounce" aria-hidden="true" />
            Download Resume
            <span className="absolute inset-0 bg-gradient-to-r from-purple-600 to-blue-600 opacity-0 group-hover:opacity-100 transition-opacity duration-300"></span>
          </a>
        </div>
      </section>

    {/* Certifications Section - Modern Card Design */}
<section aria-labelledby="certifications-heading" className="py-20 px-6">
  <div className="max-w-6xl mx-auto">
    <h2 id="certifications-heading" className="text-4xl md:text-5xl font-bold text-center mb-4 bg-gradient-to-r from-blue-400 to-purple-400 bg-clip-text text-transparent">
      Certifications
    </h2>
    <p className={`text-center mb-16 text-lg ${isDarkMode ? "text-slate-400" : "text-gray-600"}`}>
      Professional credentials validating expertise in cybersecurity and cloud technologies
    </p>
    
    {/* FLEXBOX SOLUTION - SIMPLE AND RELIABLE */}
    <div className="flex flex-wrap justify-center gap-6 md:gap-8">
      {certifications.map((cert, index) => (
        <article
          key={index}
          className={`group relative rounded-2xl p-8 border transition-all duration-300 ease-out transform hover:scale-[1.05] hover:-translate-y-2 w-full max-w-[280px] sm:max-w-[280px] lg:max-w-[264px] ${
            cert.inProgress
              ? isDarkMode
                ? "bg-gradient-to-br from-slate-800/90 to-slate-900/90 border-blue-500/50 hover:border-blue-400/70 hover:shadow-2xl hover:shadow-blue-500/30"
                : "bg-white border-blue-400/50 hover:border-blue-300/70 shadow-lg hover:shadow-2xl hover:shadow-blue-400/30"
              : isDarkMode
              ? "bg-gradient-to-br from-slate-800/90 to-slate-900/90 border-slate-700/50 hover:border-blue-500/50 hover:shadow-2xl hover:shadow-blue-500/20"
              : "bg-white border-gray-200/80 hover:border-blue-400/50 shadow-lg hover:shadow-2xl hover:shadow-blue-400/20"
          }`}
          style={{
            backdropFilter: 'blur(10px)',
            WebkitBackdropFilter: 'blur(10px)',
            ...(cert.inProgress && {
              animation: 'pulse-border 2s ease-in-out infinite',
            }),
          }}
        >
          {/* Glow effect on hover */}
          <div
            className={`absolute inset-0 rounded-2xl opacity-0 group-hover:opacity-100 transition-opacity duration-300 ${
              isDarkMode
                ? "bg-gradient-to-br from-blue-500/10 to-purple-500/10"
                : "bg-gradient-to-br from-blue-400/10 to-purple-400/10"
            }`}
          />
          
          {/* Content */}
          <div className="relative z-10 flex flex-col items-center text-center">
            {/* Logo Container */}
            <div className="w-20 h-20 md:w-24 md:h-24 mb-6 flex items-center justify-center rounded-xl p-3 transition-all duration-300 group-hover:scale-110 relative">
              <img
                src={cert.image}
                alt={`${cert.name} certification badge and logo`}
                className={`w-full h-full object-contain filter group-hover:brightness-110 transition-all duration-300 ${
                  cert.inProgress ? "opacity-70" : ""
                }`}
                loading="lazy"
                width="96"
                height="96"
              />
              {/* In Progress Overlay */}
              {cert.inProgress && (
                <div className="absolute inset-0 flex items-center justify-center">
                  <div className="absolute inset-0 bg-gradient-to-br from-blue-500/20 to-purple-500/20 rounded-xl animate-pulse" />
                </div>
              )}
            </div>
            
            {/* Title */}
            <h3 className="text-lg md:text-xl font-bold mb-2 bg-gradient-to-r from-blue-400 to-purple-400 bg-clip-text text-transparent group-hover:from-blue-300 group-hover:to-purple-300 transition-all duration-300">
              {cert.name}
            </h3>
            
            {/* Full Name */}
            <p
              className={`text-sm md:text-base leading-relaxed ${
                isDarkMode ? "text-slate-400" : "text-gray-600"
              } group-hover:text-opacity-100 transition-colors duration-300`}
            >
              {cert.fullName}
            </p>
            
            {/* In Progress Badge */}
            {cert.inProgress && (
              <div className="mt-3 px-3 py-1.5 rounded-full bg-gradient-to-r from-blue-500/20 to-purple-500/20 border border-blue-500/30 backdrop-blur-sm">
                <span className="text-xs md:text-sm font-semibold bg-gradient-to-r from-blue-400 to-purple-400 bg-clip-text text-transparent flex items-center gap-1.5">
                  <span className="relative flex h-2 w-2">
                    <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-blue-400 opacity-75"></span>
                    <span className="relative inline-flex rounded-full h-2 w-2 bg-blue-500"></span>
                  </span>
                  In Progress
                </span>
              </div>
            )}
          </div>

          {/* Decorative corner accent */}
          <div
            className={`absolute top-0 right-0 w-20 h-20 opacity-0 group-hover:opacity-100 transition-opacity duration-300 ${
              isDarkMode
                ? "bg-gradient-to-br from-blue-500/20 to-transparent"
                : "bg-gradient-to-br from-blue-400/20 to-transparent"
            }`}
            style={{
              clipPath: 'polygon(100% 0, 100% 100%, 0 0)',
              borderRadius: '0 1.5rem 0 0',
            }}
            aria-hidden="true"
          />
        </article>
      ))}
    </div>
  </div>
</section>

      {/* Projects Section - Polished Card Design */}
      <section
        aria-labelledby="projects-heading"
        className={`py-20 px-6 ${
          isDarkMode ? "bg-slate-800/50" : "bg-gray-50/50"
        }`}
      >
        <div className="max-w-6xl mx-auto">
          <h2 id="projects-heading" className="text-4xl md:text-5xl font-bold text-center mb-4 bg-gradient-to-r from-blue-400 to-purple-400 bg-clip-text text-transparent">
            Projects
          </h2>
          <p
            className={`text-center mb-16 text-lg ${
              isDarkMode ? "text-slate-400" : "text-gray-600"
            }`}
          >
            Hands-on cybersecurity projects demonstrating practical expertise
          </p>
          <div className="space-y-6 md:space-y-8">
            {projects.map((project) => (
              <article
                key={project.id}
                className={`group relative rounded-2xl p-8 md:p-10 border transition-all duration-300 ease-out transform hover:scale-[1.02] hover:-translate-y-1 ${
                  isDarkMode
                    ? "bg-gradient-to-br from-slate-800/90 to-slate-900/90 border-slate-700/50 hover:border-blue-500/50 hover:shadow-2xl hover:shadow-blue-500/20"
                    : "bg-white border-gray-200/80 hover:border-blue-400/50 shadow-lg hover:shadow-2xl hover:shadow-blue-400/20"
                }`}
                style={{
                  backdropFilter: 'blur(10px)',
                  WebkitBackdropFilter: 'blur(10px)',
                }}
              >
                {/* Glow effect on hover */}
                <div
                  className={`absolute inset-0 rounded-2xl opacity-0 group-hover:opacity-100 transition-opacity duration-300 ${
                    isDarkMode
                      ? "bg-gradient-to-br from-blue-500/10 to-purple-500/10"
                      : "bg-gradient-to-br from-blue-400/10 to-purple-400/10"
                  }`}
                />

                {/* Content */}
                <div className="relative z-10 flex flex-col lg:flex-row lg:items-start gap-6 md:gap-8">
                  {/* Main Content */}
                  <div className="flex-1">
                    {/* Title */}
                    <h3 className="text-2xl md:text-3xl font-bold mb-4 bg-gradient-to-r from-blue-400 to-purple-400 bg-clip-text text-transparent group-hover:from-blue-300 group-hover:to-purple-300 transition-all duration-300">
                      {project.title}
                    </h3>
                    
                    {/* Description */}
                    <p
                      className={`mb-6 text-base md:text-lg leading-relaxed ${
                        isDarkMode ? "text-slate-400" : "text-gray-600"
                      } group-hover:text-opacity-100 transition-colors duration-300`}
                    >
                      {project.description}
                    </p>

                    {/* Technologies */}
                    <div className="flex flex-wrap gap-2 md:gap-3">
                      {project.technologies.map((tech, index) => (
                        <span
                          key={index}
                          className={`px-3 md:px-4 py-1.5 md:py-2 rounded-full text-xs md:text-sm font-medium transition-all duration-300 group-hover:scale-105 ${
                            isDarkMode
                              ? "bg-slate-700/80 text-slate-300 border border-slate-600/50 group-hover:bg-slate-700 group-hover:border-blue-500/50"
                              : "bg-gray-200/80 text-gray-700 border border-gray-300/50 group-hover:bg-gray-200 group-hover:border-blue-400/50"
                          }`}
                        >
                          {tech}
                        </span>
                      ))}
                    </div>
                  </div>

                  {/* Action Buttons */}
                  <div className="flex gap-3 lg:flex-col lg:w-48 lg:flex-shrink-0">
                    {project.type === "pdf" ? (
                      <>
                        <button
                          onClick={() => setSelectedPDF(project)}
                          aria-label={`View ${project.title} project PDF`}
                          className="group/btn relative flex-1 lg:w-full flex items-center justify-center gap-2.5 px-6 py-3.5 bg-gradient-to-r from-blue-600 via-blue-600 to-purple-600 hover:from-blue-500 hover:via-blue-500 hover:to-purple-500 text-white rounded-xl font-semibold text-sm md:text-base transition-all duration-300 ease-out transform hover:scale-[1.05] hover:-translate-y-0.5 active:scale-[0.98] active:translate-y-0 shadow-md hover:shadow-xl hover:shadow-blue-500/40 focus:outline-none focus:ring-2 focus:ring-blue-400 focus:ring-offset-2 focus:ring-offset-transparent overflow-hidden"
                        >
                          <span className="absolute inset-0 bg-gradient-to-r from-white/0 via-white/10 to-white/0 opacity-0 group-hover/btn:opacity-100 transition-opacity duration-300 transform -skew-x-12 group-hover/btn:animate-shimmer"></span>
                          <Eye className="w-4 h-4 md:w-5 md:h-5 relative z-10 group-hover/btn:scale-110 group-hover/btn:rotate-3 transition-all duration-300" aria-hidden="true" />
                          <span className="relative z-10">View</span>
                        </button>
                        <a
                          href={project.pdfUrl}
                          download
                          target="_blank"
                          rel="noopener noreferrer"
                          aria-label={`Download ${project.title} project PDF`}
                          className={`group/btn relative flex-1 lg:w-full flex items-center justify-center gap-2.5 px-6 py-3.5 rounded-xl font-semibold text-sm md:text-base transition-all duration-300 ease-out transform hover:scale-[1.05] hover:-translate-y-0.5 active:scale-[0.98] active:translate-y-0 shadow-md hover:shadow-xl focus:outline-none focus:ring-2 focus:ring-blue-400 focus:ring-offset-2 focus:ring-offset-transparent overflow-hidden ${
                            isDarkMode
                              ? "bg-gradient-to-br from-slate-700/90 to-slate-800/90 hover:from-slate-600 hover:to-slate-700 text-white border border-slate-600/60 hover:border-slate-500/80 hover:shadow-slate-500/30"
                              : "bg-gradient-to-br from-gray-100 to-gray-200 hover:from-gray-200 hover:to-gray-300 text-gray-800 border border-gray-300/60 hover:border-gray-400/80 hover:shadow-gray-400/30"
                          }`}
                        >
                          <span className={`absolute inset-0 opacity-0 group-hover/btn:opacity-100 transition-opacity duration-300 ${
                            isDarkMode 
                              ? "bg-gradient-to-r from-white/0 via-white/5 to-white/0" 
                              : "bg-gradient-to-r from-white/0 via-white/20 to-white/0"
                          } transform -skew-x-12 group-hover/btn:animate-shimmer`}></span>
                          <Download className="w-4 h-4 md:w-5 md:h-5 relative z-10 group-hover/btn:scale-110 group-hover/btn:-translate-y-0.5 transition-all duration-300" aria-hidden="true" />
                          <span className="relative z-10">Download</span>
                        </a>
                      </>
                    ) : (
                      <a
                        href={project.url}
                        target="_blank"
                        rel="noopener noreferrer"
                        aria-label={`Visit ${project.title} project website (opens in new tab)`}
                        className="group/btn relative w-full flex items-center justify-center gap-2.5 px-6 py-3.5 bg-gradient-to-r from-blue-600 via-blue-600 to-purple-600 hover:from-blue-500 hover:via-blue-500 hover:to-purple-500 text-white rounded-xl font-semibold text-sm md:text-base transition-all duration-300 ease-out transform hover:scale-[1.05] hover:-translate-y-0.5 active:scale-[0.98] active:translate-y-0 shadow-md hover:shadow-xl hover:shadow-blue-500/40 focus:outline-none focus:ring-2 focus:ring-blue-400 focus:ring-offset-2 focus:ring-offset-transparent overflow-hidden"
                      >
                        <span className="absolute inset-0 bg-gradient-to-r from-white/0 via-white/10 to-white/0 opacity-0 group-hover/btn:opacity-100 transition-opacity duration-300 transform -skew-x-12 group-hover/btn:animate-shimmer"></span>
                        <ExternalLink className="w-4 h-4 md:w-5 md:h-5 relative z-10 group-hover/btn:scale-110 group-hover/btn:rotate-12 transition-all duration-300" aria-hidden="true" />
                        <span className="relative z-10">Visit Website</span>
                      </a>
                    )}
                  </div>
                </div>

                {/* Decorative corner accent */}
                <div
                  className={`absolute top-0 right-0 w-24 h-24 opacity-0 group-hover:opacity-100 transition-opacity duration-300 ${
                    isDarkMode
                      ? "bg-gradient-to-br from-blue-500/20 to-transparent"
                      : "bg-gradient-to-br from-blue-400/20 to-transparent"
                  }`}
                  style={{
                    clipPath: 'polygon(100% 0, 100% 100%, 0 0)',
                    borderRadius: '0 1.5rem 0 0',
                  }}
                  aria-hidden="true"
                />
              </article>
            ))}
          </div>
        </div>
      </section>

      {/* Contact Form - Polished Card Design */}
      <section aria-labelledby="contact-heading" className="py-20 px-6">
        <div className="max-w-4xl mx-auto">
          <h2 id="contact-heading" className="text-4xl md:text-5xl font-bold text-center mb-4 bg-gradient-to-r from-blue-400 to-purple-400 bg-clip-text text-transparent">
            Get In Touch
          </h2>
          <p
            className={`text-center mb-12 text-lg ${
              isDarkMode ? "text-slate-400" : "text-gray-600"
            }`}
          >
            Let's discuss how we can work together to strengthen your
            cybersecurity posture.
          </p>

          {/* Form Card */}
          <div
            className={`group relative rounded-2xl p-8 md:p-10 border transition-all duration-300 ease-out ${
              isDarkMode
                ? "bg-gradient-to-br from-slate-800/90 to-slate-900/90 border-slate-700/50 shadow-xl"
                : "bg-white border-gray-200/80 shadow-xl"
            }`}
            style={{
              backdropFilter: 'blur(10px)',
              WebkitBackdropFilter: 'blur(10px)',
            }}
          >
            {/* Glow effect on hover */}
            <div
              className={`absolute inset-0 rounded-2xl opacity-0 group-hover:opacity-100 transition-opacity duration-300 ${
                isDarkMode
                  ? "bg-gradient-to-br from-blue-500/10 to-purple-500/10"
                  : "bg-gradient-to-br from-blue-400/10 to-purple-400/10"
              }`}
            />

            {/* Form Content */}
            <form onSubmit={handleFormSubmit} className="relative z-10 space-y-6" aria-label="Contact form">
              <div className="grid md:grid-cols-2 gap-6">
                <div>
                  <label htmlFor="name" className={`block text-sm font-semibold mb-2 ${
                    isDarkMode ? "text-slate-300" : "text-gray-700"
                  }`}>
                    Name
                  </label>
                  <input
                    type="text"
                    id="name"
                    name="name"
                    value={formData.name}
                    onChange={handleInputChange}
                    required
                    aria-required="true"
                    className={`w-full px-4 py-3 border rounded-xl transition-all duration-300 focus:ring-2 focus:ring-blue-500/50 focus:border-blue-500/50 transform hover:scale-[1.02] hover:-translate-y-0.5 hover:shadow-lg ${
                      isDarkMode
                        ? "bg-slate-800/80 border-slate-700 text-white placeholder:text-slate-500 hover:bg-slate-800 hover:border-blue-500/30 hover:shadow-blue-500/20"
                        : "bg-gray-50/80 border-gray-300 text-gray-900 placeholder:text-gray-400 hover:bg-white hover:border-blue-400/50 hover:shadow-blue-400/20"
                    }`}
                    placeholder="Your full name"
                  />
                </div>
                <div>
                  <label htmlFor="email" className={`block text-sm font-semibold mb-2 ${
                    isDarkMode ? "text-slate-300" : "text-gray-700"
                  }`}>
                    Email
                  </label>
                  <input
                    type="email"
                    id="email"
                    name="email"
                    value={formData.email}
                    onChange={handleInputChange}
                    required
                    aria-required="true"
                    autoComplete="email"
                    className={`w-full px-4 py-3 border rounded-xl transition-all duration-300 focus:ring-2 focus:ring-blue-500/50 focus:border-blue-500/50 transform hover:scale-[1.02] hover:-translate-y-0.5 hover:shadow-lg ${
                      isDarkMode
                        ? "bg-slate-800/80 border-slate-700 text-white placeholder:text-slate-500 hover:bg-slate-800 hover:border-blue-500/30 hover:shadow-blue-500/20"
                        : "bg-gray-50/80 border-gray-300 text-gray-900 placeholder:text-gray-400 hover:bg-white hover:border-blue-400/50 hover:shadow-blue-400/20"
                    }`}
                    placeholder="your.email@example.com"
                  />
                </div>
              </div>

              <div>
                <label htmlFor="subject" className={`block text-sm font-semibold mb-2 ${
                  isDarkMode ? "text-slate-300" : "text-gray-700"
                }`}>
                  Subject
                </label>
                <input
                  type="text"
                  id="subject"
                  name="subject"
                  value={formData.subject}
                  onChange={handleInputChange}
                  required
                  aria-required="true"
                  className={`w-full px-4 py-3 border rounded-xl transition-all duration-300 focus:ring-2 focus:ring-blue-500/50 focus:border-blue-500/50 transform hover:scale-[1.02] hover:-translate-y-0.5 hover:shadow-lg ${
                    isDarkMode
                      ? "bg-slate-800/80 border-slate-700 text-white placeholder:text-slate-500 hover:bg-slate-800 hover:border-blue-500/30 hover:shadow-blue-500/20"
                      : "bg-gray-50/80 border-gray-300 text-gray-900 placeholder:text-gray-400 hover:bg-white hover:border-blue-400/50 hover:shadow-blue-400/20"
                  }`}
                  placeholder="What's this about?"
                />
              </div>

              <div>
                <label htmlFor="message" className={`block text-sm font-semibold mb-2 ${
                  isDarkMode ? "text-slate-300" : "text-gray-700"
                }`}>
                  Message
                </label>
                <textarea
                  id="message"
                  name="message"
                  value={formData.message}
                  onChange={handleInputChange}
                  required
                  aria-required="true"
                  rows={6}
                  className={`w-full px-4 py-3 border rounded-xl transition-all duration-300 focus:ring-2 focus:ring-blue-500/50 focus:border-blue-500/50 transform hover:scale-[1.01] hover:-translate-y-0.5 hover:shadow-lg resize-none ${
                    isDarkMode
                      ? "bg-slate-800/80 border-slate-700 text-white placeholder:text-slate-500 hover:bg-slate-800 hover:border-blue-500/30 hover:shadow-blue-500/20"
                      : "bg-gray-50/80 border-gray-300 text-gray-900 placeholder:text-gray-400 hover:bg-white hover:border-blue-400/50 hover:shadow-blue-400/20"
                  }`}
                  placeholder="Tell me more about your project or question..."
                />
              </div>

              <div className="text-center pt-2">
                <button
                  type="submit"
                  disabled={isSubmitting}
                  aria-label={isSubmitting ? "Sending message" : "Submit contact form"}
                  className="group/btn relative px-8 py-4 bg-gradient-to-r from-blue-600 to-purple-600 hover:from-blue-500 hover:to-purple-500 text-white rounded-xl font-semibold text-lg transition-all duration-300 transform hover:scale-105 hover:-translate-y-1 hover:shadow-2xl hover:shadow-blue-500/50 disabled:opacity-50 disabled:cursor-not-allowed disabled:hover:scale-100 disabled:hover:translate-y-0 disabled:hover:shadow-none overflow-hidden focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2"
                >
                  {/* Button glow effect */}
                  <span className="absolute inset-0 bg-gradient-to-r from-purple-600 to-blue-600 opacity-0 group-hover/btn:opacity-100 transition-opacity duration-300" />
                  <span className="relative z-10 flex items-center justify-center gap-2">
                    {isSubmitting ? (
                      <>
                        <span className="animate-spin">⏳</span>
                        Sending...
                      </>
                    ) : (
                      "Send Message"
                    )}
                  </span>
                </button>
              </div>
            </form>

            {/* Decorative corner accent */}
            <div
              className={`absolute top-0 right-0 w-24 h-24 opacity-0 group-hover:opacity-100 transition-opacity duration-300 ${
                isDarkMode
                  ? "bg-gradient-to-br from-blue-500/20 to-transparent"
                  : "bg-gradient-to-br from-blue-400/20 to-transparent"
              }`}
              style={{
                clipPath: 'polygon(100% 0, 100% 100%, 0 0)',
                borderRadius: '0 1.5rem 0 0',
              }}
            />
          </div>

          {/* Info Box */}
          <div
            className={`group relative mt-12 text-center p-6 md:p-8 rounded-2xl border transition-all duration-300 ${
              isDarkMode
                ? "bg-gradient-to-br from-slate-800/90 to-slate-900/90 border-slate-700/50 hover:border-blue-500/50 hover:shadow-xl hover:shadow-blue-500/20"
                : "bg-white border-gray-200/80 hover:border-blue-400/50 hover:shadow-xl hover:shadow-blue-400/20"
            }`}
            style={{
              backdropFilter: 'blur(10px)',
              WebkitBackdropFilter: 'blur(10px)',
            }}
          >
            <p
              className={`mb-3 text-base md:text-lg ${
                isDarkMode ? "text-slate-400" : "text-gray-600"
              }`}
            >
              Ready to enhance your organization's security? I'm here to help
              you build robust defenses against today's evolving cyber threats.
            </p>
            <p className="text-blue-400 font-semibold text-lg">
              <a
                href="mailto:Ariboifeoluwa@gmail.com"
                target="_blank"
                rel="noopener noreferrer"
                className="hover:text-blue-300 focus:text-blue-300 outline-none transition-all duration-300 inline-flex items-center gap-2 hover:scale-105"
              >
                <span>📧</span>
                <span>Ariboifeoluwa@gmail.com</span>
              </a>
            </p>
          </div>
        </div>
      </section>

      {/* Success Modal */}
      {showSuccessModal && (
        <div className="fixed inset-0 z-50 bg-black/80 backdrop-blur-sm flex items-center justify-center p-6">
          <div
            className={`rounded-2xl max-w-md w-full p-8 text-center transition-all duration-300 transform ${
              isDarkMode ? "bg-slate-800" : "bg-white"
            }`}
          >
            <div className="w-16 h-16 mx-auto mb-6 bg-green-100 rounded-full flex items-center justify-center">
              <Check className="w-8 h-8 text-green-600" />
            </div>
            <h3 className="text-2xl font-bold mb-4 text-green-600">
              Message Sent!
            </h3>
            <p
              className={`mb-6 text-lg ${
                isDarkMode ? "text-slate-300" : "text-gray-600"
              }`}
            >
              Thank you for reaching out! I'll get back to you as soon as
              possible with a detailed response.
            </p>
            <button
              onClick={() => setShowSuccessModal(false)}
              className="px-6 py-3 bg-blue-600 hover:bg-blue-700 text-white rounded-xl font-semibold transition-colors"
            >
              Got it!
            </button>
          </div>
        </div>
      )}

      {/* PDF Popup Overlay */}
      {selectedPDF && (
        <div className="fixed inset-0 z-50 bg-black/80 backdrop-blur-sm flex items-center justify-center p-6">
          <div
            className={`rounded-xl w-full max-w-4xl h-[80vh] flex flex-col ${
              isDarkMode ? "bg-slate-800" : "bg-white"
            }`}
          >
            <div
              className={`flex items-center justify-between p-4 border-b ${
                isDarkMode ? "border-slate-700" : "border-gray-200"
              }`}
            >
              <h3 className="text-lg font-semibold">{selectedPDF.title}</h3>
              <button
                onClick={() => setSelectedPDF(null)}
                className={`p-2 rounded-lg transition-colors ${
                  isDarkMode ? "hover:bg-slate-700" : "hover:bg-gray-100"
                }`}
              >
                <X className="w-5 h-5" />
              </button>
            </div>
            <div className="flex-1 p-4">
              <div
                className={`w-full h-full rounded-lg flex items-center justify-center ${
                  isDarkMode ? "bg-slate-700" : "bg-gray-100"
                }`}
              >
                <div className="text-center">
                  <div className="text-4xl mb-4">📄</div>
                  <p
                    className={`mb-4 ${
                      isDarkMode ? "text-slate-400" : "text-gray-600"
                    }`}
                  >
                    PDF Viewer would be embedded here
                  </p>
                  <a
                    href={selectedPDF.pdfUrl}
                    download
                    target="_blank"
                    rel="noopener noreferrer"
                    className="inline-flex items-center gap-2 px-4 py-2 bg-blue-600 hover:bg-blue-700 text-white rounded-lg transition-colors"
                  >
                    <Download className="w-4 h-4" />
                    Download PDF
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}

      <style jsx global>{`
        @keyframes fadeInUp {
          from {
            opacity: 0;
            transform: translateY(30px);
          }
          to {
            opacity: 1;
            transform: translateY(0);
          }
        }
        
        .animate-fade-in-up {
          animation: fadeInUp 0.6s ease-out;
        }
        
        @keyframes pulse {
          0%, 100% {
            transform: scale(1);
          }
          50% {
            transform: scale(1.05);
          }
        }
        
        .animate-pulse-slow {
          animation: pulse 2s ease-in-out infinite;
        }
        
        @keyframes pulse-border {
          0%, 100% {
            border-color: rgba(59, 130, 246, 0.5);
            box-shadow: 0 0 0 0 rgba(59, 130, 246, 0.4);
          }
          50% {
            border-color: rgba(59, 130, 246, 0.7);
            box-shadow: 0 0 0 4px rgba(59, 130, 246, 0.1);
          }
        }
        
        @keyframes shimmer {
          0% {
            transform: translateX(-100%) skewX(-12deg);
          }
          100% {
            transform: translateX(200%) skewX(-12deg);
          }
        }
        
        .animate-shimmer {
          animation: shimmer 1.5s ease-in-out infinite;
        }

        /* Custom scrollbar styles */
        .scrollbar-thin::-webkit-scrollbar {
          height: 6px;
        }
        
        .scrollbar-track-transparent::-webkit-scrollbar-track {
          background: transparent;
        }
        
        .scrollbar-thumb-blue-500/30::-webkit-scrollbar-thumb {
          background-color: rgba(59, 130, 246, 0.3);
          border-radius: 3px;
        }
        
        .scrollbar-thumb-blue-500/30::-webkit-scrollbar-thumb:hover {
          background-color: rgba(59, 130, 246, 0.5);
        }
        @import url('https://fonts.googleapis.com/css2?family=Orbitron:wght@700&display=swap');
  .futuristic-logo {
    animation: logo-glow 2.5s ease-in-out infinite alternate;
  }
  @keyframes logo-glow {
    0% {
      text-shadow: 0 0 8px #0ff, 0 0 2px #00f;
    }
    100% {
      text-shadow: 0 0 16px #7df, 0 0 4px #aaf;
    }
  }
  .neon-logo {
    box-shadow: 0 0 8px #00fff0, 0 0 2px #3b82f6;
    animation: neon-flicker 2.5s infinite alternate;
  }
  @keyframes neon-flicker {
    0% {
      text-shadow: 0 0 8px #00fff0, 0 0 2px #3b82f6;
      filter: brightness(1.1);
    }
    100% {
      text-shadow: 0 0 24px #00fff0, 0 0 8px #a21caf;
      filter: brightness(1.3);
    }
  }
  .logo-text {
    text-shadow: 0 2px 8px rgba(59,130,246,0.10), 0 1px 2px rgba(168,85,247,0.10);
    transition: text-shadow 0.2s, transform 0.2s;
  }
  .logo-text:hover, .logo-text:focus {
    text-shadow: 0 4px 16px rgba(59,130,246,0.18), 0 2px 8px rgba(168,85,247,0.18);
  }

  /* Consistent Button Styling */
  .btn-main,
  .btn-main:visited {
    @apply bg-gradient-to-r from-blue-600 to-purple-600 text-white font-semibold rounded-xl transition-all duration-300 transform;
    box-shadow: none;
    position: relative;
    overflow: hidden;
  }
  .btn-main:hover,
  .btn-main:focus {
    @apply scale-105 shadow-2xl;
  }
  .btn-main::after {
    content: "";
    @apply absolute inset-0 bg-gradient-to-r from-purple-600 to-blue-600 opacity-0 transition-opacity duration-300;
    z-index: 0;
  }
  .btn-main:hover::after,
  .btn-main:focus::after {
    opacity: 1;
  }
  .btn-main > * {
    position: relative;
    z-index: 1;
  }

  /* Remove default button background for secondary buttons */
  .btn-secondary,
  .btn-secondary:visited {
    @apply bg-gray-200 text-gray-700 rounded-lg transition-all duration-300 transform;
    box-shadow: none;
    position: relative;
    overflow: hidden;
  }
  .btn-secondary:hover,
  .btn-secondary:focus {
    @apply scale-105 shadow-2xl bg-gray-300;
  }
  .btn-secondary > * {
    position: relative;
    z-index: 1;
  }
      `}</style>
      </main>
    </div>
  );
}
